import { Currency } from "../../../models/court-pricing/dto/court-pricing-rule.dto";
import { CompactAvailabilityBlockDto } from "../../../models/court/dto/batch-upsert-availabilities-compact.dto";
import { MINUTES_PER_SLOT, CreateCourtFormAvailabilityInputType } from "../../../models/court/dto/court-availability-template.constants";
import { SportType } from "../../../models/court/dto/court.dto";

/**
 * Builds the compact availability blocks sent to POST
 * /courts/:id/availabilities/compact (and create-court's compactAvailabilities).
 *
 * The form holds `min`/`max` as slot indices (SLOTS_PER_HOUR = 4, so one slot =
 * 15 min); the server wants wall-clock minutes from local midnight, hence
 * `index * MINUTES_PER_SLOT`. Per-config sport/currency/price fall back to the
 * provided defaults (the modal has no price fallback because it validates price
 * up front; create-court falls back to the court's default price).
 *
 * This is a pure function so the payload wiring is unit-tested independently of
 * the components. The timezone is added by the caller (it reads a browser global).
 */
export function buildCompactAvailabilityBlocks(
    availabilities: CreateCourtFormAvailabilityInputType[],
    fallbacks: { price?: number; sport: SportType; currency: Currency },
): CompactAvailabilityBlockDto[] {
    return availabilities.map((a) => ({
        daysOfWeek: a.daysOfWeek,
        startMinuteOfDay: a.min * MINUTES_PER_SLOT,
        endMinuteOfDay: a.max * MINUTES_PER_SLOT,
        configs: a.configurations.map((config) => ({
            id: config.id,
            price: (config.price ?? fallbacks.price) as number,
            slotDurationInMs: config.slotDurationInMs,
            sport: config.sport ?? fallbacks.sport,
            currency: config.currency ?? fallbacks.currency,
            capacity: config.capacity,
        })),
    }));
}
